enum TestSelectionFormFieldNames {
    isPersonalitySelected = 'isPersonalitySelected',
    isAptitudeSelected = 'isAptitudeSelected',
    isSkillsSelected = 'isSkillsSelected',
    isEmotionalIntelligenceSelected = 'isEmotionalIntelligenceSelected',
}

export default TestSelectionFormFieldNames;
